/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgForward = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22c-5 0-9-4-9-9 0-4.8 3.8-8.8 8.6-9l-1.3-1.3 1.4-1.4L15.4 5l-3.7 3.7-1.4-1.4L11.6 6C7.9 6.2 5 9.3 5 13c0 3.9 3.1 7 7 7s7-3.1 7-7h2c0 5-4 9-9 9z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgForward as Forward };
